import { CalendarBlank, ChartBar, Files, Folders } from "@phosphor-icons/react"

const shortcuts = [
    {
        id: 'dashboardOperacional',
        label: 'Dashboard Operacional',
        icon: ChartBar,
        url: 'dashboards/operacional'
    },
    {
        id: 'listaVidas',
        label: 'Lista de Vidas',
        icon: Folders,
        url: 'administracao/vidas'
    },
]

export { shortcuts }